import React from 'react';
import { Card } from './ui/card';
import { ChevronRight } from 'lucide-react';

const PortfolioCard = ({ icon: Icon, title, subtitle, onClick, gradient }) => {
  return (
    <Card 
      className="bg-slate-900 border-slate-800 p-8 cursor-pointer hover:border-blue-700 transition-all hover:shadow-xl hover:shadow-blue-900/20 hover:scale-105 group"
      onClick={onClick}
    >
      <div className="flex flex-col items-center text-center">
        <div className={`mb-4 p-4 rounded-full ${gradient}`}>
          <Icon className="text-white" size={40} />
        </div>
        <h3 className="text-2xl font-bold text-white mb-2">{title}</h3>
        <p className="text-slate-400 mb-4">{subtitle}</p>
        <div className="flex items-center gap-1 text-blue-400 group-hover:gap-2 transition-all">
          <span className="text-sm font-medium">View Details</span>
          <ChevronRight size={18} />
        </div>
      </div>
    </Card>
  );
};

export default PortfolioCard;
